const paginationData = JSON.parse(document.querySelector('#paginationData').textContent);
const pagination_element = document.getElementById('pagination-almanac-all');
const list_elements = document.getElementById('articles_almanac_section_main');
const nextPage = document.getElementById("nextPage");
const previousPage = document.getElementById("previousPage");


let currentPage = 1;
let rows = 6;
let maxPageNumbers = 3;

    // function truncate( str, n, useWordBoundary ){
    //     if (str !== undefined) {
    //         const subString = str.substr(0, n-1); // the original check
    //         console.log(subString);
    //         console.log(useWordBoundary)
    //         return (useWordBoundary
    //         ? subString.substr(0, subString.lastIndexOf(" ")) 
    //         : subString) + "&hellip;";
    //     }
    // };

    function DisplayList (items, wrapper, rows_per_page, page) {
        wrapper.innerHTML = "";
        page--;

        let start = rows_per_page * page;
        let end = start + rows_per_page;
        let paginatedItems = items.slice(start, end);

        paginatedItems.forEach((item, i) => {
            let list_element = document.createElement('div');
            list_element.classList.add('list_element');

            const truncate = (str, max, suffix) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;
            let body = truncate(paginatedItems[i].description, 110, '...');

            list_element.innerHTML = `
                <a href="${paginatedItems[i].link}">
                    <div>
                        <img src="${paginatedItems[i].image}" class="imgs lazyload article_almanac_img">
                    </div> 
                    <div class="article_content">
                        <h3 class="article_title">${paginatedItems[i].title}</h3>
                        <p>${body}</p>
                    </div>
                </a>
            `;
            wrapper.appendChild(list_element);
        })
    }

    function getPagination(page, total) {
        if (page < 3) return [1, 2, 3, '...'];
        if (page < total - 2) return ['...', page - 1, page, '...'];
        return [1, '...', total - 2, total - 1];
    }
    
    function SetupPagination(items, wrapper, rows_per_page) {
        wrapper.innerHTML = "";
        let page_count = Math.ceil(items.length / rows_per_page);

        //validating pages based on page count
        if (currentPage < 1 ) currentPage = 1;
        if (currentPage >  page_count ) currentPage = page_count;

        let start = Math.max(1, currentPage - 2)
        let end = Math.min(start + 2, page_count - 1)

        for (var i = start; i <= end; i++) {
            // Render each element, but the active one differently.
            let btn = PaginationButton(i, items);
            wrapper.appendChild(btn);
        }

        // Render the next and previous buttons.

        //go to previus page
        if (currentPage > maxPageNumbers) {
            previousPage.innerHTML = "";
            let prev = document.createElement('a');
            prev.innerHTML = "...";
            prev.classList.add('btn_prev_almanac');
            previousPage.appendChild(prev);
            prev.addEventListener('click', function() {
                currentPage--;
                DisplayList(paginationData, list_elements, rows, currentPage);
                SetupPagination(paginationData, pagination_element, rows);
            });
           
        } else {
            previousPage.innerHTML = "";
        }

        //go to next page
        if (currentPage < page_count) {
            nextPage.innerHTML = "";
            let next = document.createElement('a');
            next.innerHTML = "...";
            next.classList.add('btn_next_almanac');
            nextPage.appendChild(next);
            next.addEventListener('click', function() {
                currentPage++;
                DisplayList(paginationData, list_elements, rows, currentPage);
                SetupPagination(paginationData, pagination_element, rows);
            });
        }else {
            nextPage.innerHTML = "";
        }

    }

    function PaginationButton(page, items) {
        let btn = document.createElement('button');
        btn.innerHTML = page;
        btn.classList.add('btn_almanac');

        if (currentPage == page) {
            btn.classList.add('active');
        }


        btn.addEventListener('click', function() {
            currentPage = btn.innerHTML;
            DisplayList(items, list_elements, rows, currentPage);
            let current_btn = document.querySelector('.btn_almanac.active');
            current_btn.classList.remove('active');
            btn.classList.add('active');
        });

        return btn;
    }

    function groupBy(list, keyGetter) {
        const map = new Map();
        for(let i = 0; i < list.length; i++){
            const key = keyGetter(list[i]);
            const collection = map.get(key);
            if(!collection){
                map.set(key, [list[i]]);
            }else{
                collection.push(list[i]);
            }
        }
        return map;
    }



const dataArticles = paginationData.map(obj => obj);
const articles = dataArticles;
console.log("articles", articles)

articles.forEach((article, i) => {
    // let all_link = document.querySelector('.all_blogs');
    let category_link = document.querySelectorAll('.almanac_blog_category_link');
    // all_link.addEventListener('click', function(){
    //         event.preventDefault();

    //         category_link.forEach(l => l.classList.remove('active'));
    //         all_link.classList.add('active');
  
    //         let filtered_articles = articles;
    //         DisplayList(filtered_articles, list_elements, rows, currentPage);
    //         SetupPagination(filtered_articles, pagination_element, rows);
    //     });
    if(articles[i].categories !== undefined){
        category_link.forEach(link => {
            link.addEventListener('click', function(){

                [...category_link].filter(l => l !== link).forEach(l => l.classList.remove('active'));
                // all_link.classList.remove('active');
                link.classList.add('active');
        
                let category_name = link.innerHTML;
                let filtered_articles = articles.filter(article => article.categories[0] === category_name);
                DisplayList(filtered_articles, list_elements, rows, currentPage);
                SetupPagination(filtered_articles, pagination_element, rows);
            });
        });
     } else {
        DisplayList(articles, list_elements, rows, currentPage);
        SetupPagination(articles, pagination_element, rows);
    }
})






DisplayList(paginationData, list_elements, rows, currentPage);
SetupPagination(paginationData, pagination_element, rows);